import React from "react";

export const Twint = () => {
  return (
    <svg
      role="img"
      aria-label="Twint logo"
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="32"
      viewBox="0 0 62 32"
      fill="none"
    >
      <path
        d="M54.7999 0H6.7999C3.26528 0 0.399902 2.86538 0.399902 6.4V25.6C0.399902 29.1346 3.26528 32 6.7999 32H54.7999C58.3345 32 61.1999 29.1346 61.1999 25.6V6.4C61.1999 2.86538 58.3345 0 54.7999 0Z"
        fill="white"
      />
      <path
        d="M20.75 21.2814C20.75 21.4915 20.6009 21.7417 20.4221 21.8417L14.1028 25.5237C13.9239 25.6238 13.6259 25.6238 13.447 25.5237L7.12769 21.8417C6.94884 21.7417 6.7998 21.4815 6.7998 21.2814V13.9174C6.7998 13.7072 6.94884 13.4571 7.12769 13.357L13.447 9.67502C13.6259 9.57496 13.9239 9.57496 14.1028 9.67502L20.4221 13.357C20.6009 13.4571 20.75 13.7172 20.75 13.9174V21.2814ZM55.8341 14.4476H50.1805V15.8084H52.2075V21.6316H53.8072V15.8084H55.8341V14.4476ZM30.1296 14.4476H24.4661V15.8084H26.493V21.6316H28.0927V15.8084H30.1197L30.1296 14.4476ZM46.5042 14.2275C44.7256 14.2275 43.732 15.3782 43.732 17.0291V21.6416H45.3218V16.9991C45.3218 16.2787 45.7391 15.7183 46.524 15.7183C47.309 15.7183 47.7164 16.3787 47.7164 16.9991V21.6416H49.2962V17.0291C49.3161 15.3682 48.2927 14.2275 46.5042 14.2275ZM40.5326 14.4476V21.6316H42.1125V14.4476H40.5326ZM35.1572 17.2992L35.2069 17.6194L36.6973 21.6416H37.3432L39.3701 14.4577H37.8101L36.8464 18.2297L36.7867 18.64L36.7073 18.2297L35.4156 14.4577H34.8989L33.6072 18.2297L33.5277 18.64L33.478 18.2297L32.5142 14.4577H30.9444L32.9713 21.6416H33.6171L35.1076 17.6194L35.1572 17.2992Z"
        fill="#050505"
      />
      <path
        d="M17.0734 17.6194L15.4241 20.0607L14.5795 18.76L15.5532 17.2892C15.7321 17.029 16.1196 16.3087 15.6725 15.3281C15.3148 14.5277 14.5298 14.1475 13.8343 14.1475C13.1388 14.1475 12.3936 14.5077 11.9961 15.3281C11.5391 16.2786 11.9365 17.009 12.1054 17.2592C12.1054 17.2592 12.6519 18.0596 13.099 18.73L13.8343 19.8006L14.9372 21.5015C14.9471 21.5115 15.116 21.7817 15.4241 21.7817C15.7122 21.7817 15.901 21.5115 15.9209 21.4915L18.5042 17.6394H17.0734V17.6194ZM13.8243 17.6794C13.8243 17.6794 13.3971 17.019 13.109 16.5588C12.8109 16.0685 13.1388 15.3281 13.8243 15.3281C14.5 15.3281 14.8378 16.0685 14.5397 16.5588C14.2615 17.019 13.8243 17.6794 13.8243 17.6794Z"
        fill="url(#paint0_radial_1789_1934)"
      />
      <path
        d="M12.2444 19.9807L10.6248 17.6894C10.6248 17.6894 10.1976 17.029 9.90942 16.5688C9.61134 16.0785 9.93923 15.3381 10.6248 15.3381C10.7142 15.3381 10.7838 15.3481 10.8633 15.3681L11.4296 14.3176C11.1713 14.2075 10.8831 14.1475 10.6248 14.1475C9.93923 14.1475 9.18409 14.5077 8.78665 15.3281C8.32959 16.2786 8.72703 17.009 8.89594 17.2592L11.7277 21.4915C11.7575 21.5215 11.9364 21.7917 12.2344 21.7917C12.5325 21.7917 12.7114 21.5315 12.7312 21.5015L13.5857 20.1908L12.8505 19.1102L12.2444 19.9807Z"
        fill="url(#paint1_radial_1789_1934)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1789_1934"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.2899 14.8175) scale(7.61423 8.65505)"
        >
          <stop stopColor="#FFCC00" />
          <stop offset="0.09157" stopColor="#FFC800" />
          <stop offset="0.1739" stopColor="#FFBD00" />
          <stop offset="0.2528" stopColor="#FFAB00" />
          <stop offset="0.3295" stopColor="#FF9100" />
          <stop offset="0.4046" stopColor="#FF7000" />
          <stop offset="0.4786" stopColor="#FF4700" />
          <stop offset="0.5503" stopColor="#FF1800" />
          <stop offset="0.5822" stopColor="#FF0000" />
          <stop offset="1" stopColor="#FF0000" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_1789_1934"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.70028 15.2596) scale(6.98136 10.6445)"
        >
          <stop stopColor="#00B4E6" />
          <stop offset="0.201" stopColor="#00B0E3" />
          <stop offset="0.3898" stopColor="#01A5DB" />
          <stop offset="0.5737" stopColor="#0292CD" />
          <stop offset="0.7546" stopColor="#0377BA" />
          <stop offset="0.9316" stopColor="#0455A1" />
          <stop offset="1" stopColor="#054696" />
        </radialGradient>
      </defs>
    </svg>
  );
};
